var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.333 11L9.90444 6.99996M6.09491 6.99996L1.66636 11M1.33301 3.66663L6.77629 7.47692C7.21707 7.78547 7.43746 7.93974 7.67718 7.9995C7.88894 8.05228 8.11041 8.05228 8.32217 7.9995C8.56189 7.93974 8.78228 7.78547 9.22306 7.47692L14.6663 3.66663M4.53301 12.3333H11.4663C12.5864 12.3333 13.1465 12.3333 13.5743 12.1153C13.9506 11.9236 14.2566 11.6176 14.4484 11.2413C14.6663 10.8134 14.6663 10.2534 14.6663 9.13329V4.86663C14.6663 3.74652 14.6663 3.18647 14.4484 2.75864C14.2566 2.38232 13.9506 2.07636 13.5743 1.88461C13.1465 1.66663 12.5864 1.66663 11.4663 1.66663H4.53301C3.4129 1.66663 2.85285 1.66663 2.42503 1.88461C2.0487 2.07636 1.74274 2.38232 1.55099 2.75864C1.33301 3.18647 1.33301 3.74652 1.33301 4.86663V9.13329C1.33301 10.2534 1.33301 10.8134 1.55099 11.2413C1.74274 11.6176 2.0487 11.9236 2.42503 12.1153C2.85285 12.3333 3.4129 12.3333 4.53301 12.3333Z",
    stroke: "#5A5A5A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.d92e7a60158c61d4a0f988326a571246.svg";
export { ForwardRef as ReactComponent };